import {AxiosError} from 'axios'
import {SuccessfulNotify, UnsuccessfulNotify} from '../../../../../ToastMetods'
import {KTSVG} from '../../../../../_metronic/helpers'
import {useFormik} from 'formik'
import {
  generateReferencesCode,
  getClaimsList,
  listUnitTree,
} from '../../../../modules/auth/core/_requests'
import {useEffect, useState} from 'react'
import * as Yup from 'yup'
import * as bootstrap from 'bootstrap'

const profileDetailsSchema = Yup.object().shape({})

function ReferencesCodeEditModal({editData, setAction}: any) {
  const [units, setUnits] = useState<[]>([])
  const [roles, setRole] = useState<[]>([])

  const initialValues = {
    code: String(editData?.code) || '',
    expireDate: editData.expireDate || new Date(),
    referencesType: 1,
    fkId: editData.fkId || 0,
    claimId: editData.userRole || 0,
  }

  // 👇 Role Listesi
  const getListClaims = async () => {
    try {
      const {data} = await getClaimsList()
      setRole(data)
    } catch (err) {
      const error = `${(err as AxiosError)?.response?.data}`
      console.error(error)
    }
  }

  // 👇 Birim  Listesi
  const getListUnits = async () => {
    try {
      const {data} = await listUnitTree(0, 0)
      setUnits(extractData(data))
    } catch (err) {
      const error = `${(err as AxiosError)?.response?.data}`
      console.error(error)
    }
  }

  // 👇 Birim Ağaç yapısından değerleri dön
  function extractData(data: any, parentName: string = '') {
    const result: any = []
    data.forEach((item: any) => {
      const fullName = parentName ? `${parentName}|${item.name}` : item.name
      result.push({id: item.id, name: fullName})
      if (item.subList && item.subList.length > 0) {
        result.push(...extractData(item.subList, fullName))
      }
    })
    return result
  }

  useEffect(() => {
    getListClaims()
    getListUnits()
  }, [])

  const formik = useFormik({
    enableReinitialize: true,
    initialValues,
    validationSchema: profileDetailsSchema,
    onSubmit: async (values) => {
      try {
        const {data} = await generateReferencesCode(
          Number(editData.id),
          values.code,
          values.expireDate,
          values.fkId,
          values.referencesType,
          values.claimId
        )
        setAction(true)
        formik.resetForm()
        //Modal close
        const modal = bootstrap.Modal.getOrCreateInstance('#editReferencesCode_modal')
        modal.hide()
        //
        SuccessfulNotify('Registration Successfully Added.')
      } catch (err) {
        const error = `${(err as AxiosError)?.response?.data}`
        console.error(error)
        UnsuccessfulNotify(String(error))
      }
    },
  })

  return (
    <div className='modal fade' tabIndex={-1} id='editReferencesCode_modal'>
      <div className='modal-dialog '>
        <div className='modal-content'>
          <div className='modal-header'>
            <h5 className='modal-title'>Edit References Code</h5>
            <div
              className='btn btn-icon btn-sm btn-active-light-primary ms-2'
              data-bs-dismiss='modal'
              aria-label='Close'
            >
              <KTSVG
                path='/media/icons/duotune/arrows/arr061.svg'
                className='svg-icon svg-icon-2x'
              />
            </div>
          </div>
          <div className='modal-body'>
            <form onSubmit={formik.handleSubmit} noValidate className='form'>
              <div className='modal-body'>
                {/*From*/}
                {/* 👇 Code  👇 */}
                <div className='mb-10'>
                  <label className='form-label'>Code</label>
                  <div className='input-group'>
                    <input
                      type='text'
                      className='form-control badge-light-primary '
                      placeholder='Code'
                      {...formik.getFieldProps('code')}
                      disabled
                    />
                    {formik.values.code && (
                      <a
                        className='btn btn-icon btn-outline-success rounded position-absolute end-0'
                        onClick={() => navigator.clipboard.writeText(formik.values.code)}
                        title='Copy'
                      >
                        <span className='bi bi-clipboard'></span>
                      </a>
                    )}
                  </div>
                </div>
                {/* 👆 Code 👆 */}
                {/* 👇 Unit  👇 */}
                <div className='mb-10'>
                  <label className='form-label fw-bold'>Unit</label>
                  <select
                    className='form-select form-select-solid'
                    data-kt-select2='true'
                    data-placeholder='Select option'
                    data-allow-clear='true'
                    {...formik.getFieldProps('fkId')}
                  >
                    {units.map((item: any, index: number) => (
                      <option key={index} value={item.id}>
                        {item.name}
                      </option>
                    ))}
                  </select>
                </div>
                {/* 👆 Unit 👆 */}

                {/* 👇 Role 👇 */}
                <div className='mb-10'>
                  <label className='form-label fw-bold'>Role</label>

                  <select
                    className='form-select form-select-solid'
                    data-kt-select2='true'
                    data-placeholder='Select option'
                    data-allow-clear='true'
                    {...formik.getFieldProps('claimId')}
                  >
                    {roles.map((item: any, index: number) => (
                      <option key={index} value={item.id}>
                        {item.name}
                      </option>
                    ))}
                  </select>
                </div>
                {/* 👆 Role 👆 */}
                {/* 👇 Expire Date 👇 */}
                <div className='mb-10'>
                  <label className='form-label'>Expire Date </label>
                  <input
                    type='date'
                    className='form-control '
                    placeholder='Expire Date'
                    value={
                      formik.values.expireDate
                        ? new Date(formik.values.expireDate)
                            .toLocaleDateString('tr-TR')
                            .split('.')
                            .reverse()
                            .join('-')
                        : ''
                    }
                    onChange={(e) => {
                      const selectedDate = e.target.value
                      const date = new Date(selectedDate)
                      formik.setFieldValue('expireDate', date.toISOString())
                    }}
                  />
                </div>
                {/* 👆 Expire Date 👆 */}

                {/*End Form */}
              </div>
              <div className='modal-footer'>
                <button type='button' className='btn btn-light' data-bs-dismiss='modal'>
                  Close
                </button>

                <button type='submit' className='btn btn-primary'>
                  Update References Code
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ReferencesCodeEditModal
